export default function videoIframePlayers(Alpine) {
  Alpine.directive(
    'youtube',
    async (el, { expression, modifiers }, { effect, evaluateLater }) => {
      let loop = null;
      let toggleVideoPlayback = evaluateLater(expression);
      const iframe = el.tagName === 'IFRAME' ? el : el.querySelector('iframe');

      while (!YT?.loaded) {
        await new Promise((resolve) => setTimeout(resolve, 100));
      }

      const yt = new YT.Player(iframe, {
        events: {
          onReady: (event) => {
            event.target.playVideo();

            effect(() => {
              toggleVideoPlayback((play) => {
                if (play) {
                  event.target.playVideo();
                } else {
                  event.target.seekTo(0);
                  event.target.pauseVideo();
                }
              });
            });
          },
          onStateChange: (event) => {
            if (!modifiers.includes('preview')) {
              return;
            }

            if (event.data === YT.PlayerState.PLAYING) {
              loop = setInterval(() => {
                event.target.seekTo(0);
              }, 5000);
            } else {
              clearInterval(loop);
            }
          }
        }
      });
    }
  );

  Alpine.directive(
    'vimeo',
    (el, { expression, modifiers }, { effect, evaluateLater }) => {
      let loop = null;
      let toggleVideoPlayback = evaluateLater(expression);
      const iframe = el.tagName === 'IFRAME' ? el : el.querySelector('iframe');

      const player = new Vimeo.Player(iframe);

      if (modifiers.includes('preview')) {
        player.on('play', function () {
          loop = setInterval(() => {
            player.setCurrentTime(0);
          }, 5000);
        });

        player.on('pause', () => {
          clearInterval(loop);
        });
      }

      player.on('loaded', () => {
        effect(() => {
          toggleVideoPlayback((play) => {
            if (play) {
              player.play();
            } else {
              player.pause();
            }
          });
        });
      });
    }
  );
}
